/** Size of Skyline Stacker's world, in studs — shared by the rules and the drawing. */
export const FIELD_WIDTH = 16;
export const START_WIDTH = 9;
